import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './auth';
import { I18nProvider } from './i18n';

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <I18nProvider>
    <AuthProvider>
      <App />
    </AuthProvider>
  </I18nProvider>,
);
